import { createAction } from '@reduxjs/toolkit'
export const socketConnectedAction = createAction('@@socket/SOCKET_CONNECTED')
